/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FoundShippingInstructionsDTO { 
    id?: number;
    billOfLadingType?: FoundShippingInstructionsDTO.BillOfLadingTypeEnum;
    numberOfOriginals?: number;
    numberOfCopies?: number;
    portOfLoading?: string;
    portOfDischarge?: string;
    placeOfReceipt?: string;
    placeOfDestination?: string;
    numberOfContainers?: number;
    status?: FoundShippingInstructionsDTO.StatusEnum;
}
export namespace FoundShippingInstructionsDTO {
    export type BillOfLadingTypeEnum = 0 | 1;
    export const BillOfLadingTypeEnum = {
        NUMBER_0: 0 as BillOfLadingTypeEnum,
        NUMBER_1: 1 as BillOfLadingTypeEnum
    };
    export type StatusEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;
    export const StatusEnum = {
        NUMBER_0: 0 as StatusEnum,
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum,
        NUMBER_4: 4 as StatusEnum,
        NUMBER_5: 5 as StatusEnum,
        NUMBER_6: 6 as StatusEnum
    };
}